/**
 * Reads the CSRF token the server left in a readable cookie.
 *
 * The session cookie beside it is `HttpOnly` and deliberately unreadable; this one is not, because
 * its whole job is to be copied into a request header. That asymmetry is the double-submit pattern:
 * a cross-site form post can make the browser send cookies, but it cannot make it send a header, so
 * a request carrying the matching header must have come from a page on this origin.
 *
 * Two names are tried because the server adds the `__Host-` prefix only when the cookie is marked
 * `Secure`, which a deployment can turn off. Guessing wrong would leave every write refused with no
 * clue why.
 */
const CANDIDATE_NAMES = ['__Host-ipd.customer.csrf', 'ipd.customer.csrf'];

export const CSRF_HEADER = 'X-CSRF-Token';

export function readCsrfToken(): string | null {
    // The prerender step runs this bundle in Node, where there is no document to read.
    if (typeof document === 'undefined') {
        return null;
    }

    for (const name of CANDIDATE_NAMES) {
        const value = readCookie(name);

        if (value !== null) {
            return value;
        }
    }

    return null;
}

function readCookie(name: string): string | null {
    const prefix = `${name}=`;

    for (const part of document.cookie.split('; ')) {
        if (part.startsWith(prefix)) {
            return decodeURIComponent(part.slice(prefix.length));
        }
    }

    return null;
}
